/* eslint-disable max-len */
import Vue from 'vue';
import VueRouter from 'vue-router';
import requireRoles from './guard';
import checkForHilfeVideo from './hilfe';
import secretGuard from './secretGuard';
import routes from './routes';

Vue.use(VueRouter);

const routerMode = import.meta.env.VITEST ? 'abstract' : 'hash';

const router = new VueRouter({
  mode: routerMode,
  routes,
});

if (import.meta.env.VITEST) {
  const originalResolve = router.resolve.bind(router);

  router.resolve = (...args) => {
    const resolved = originalResolve(...args);
    const normalizedHref = resolved.href.startsWith('#') ? resolved.href : `#${resolved.href}`;

    return {
      ...resolved,
      href: normalizedHref,
    };
  };
}

router.beforeEach((to, from, next) => {
  secretGuard(to, from, next);
  requireRoles(to, from, next);
  checkForHilfeVideo(to, from, next);
});

export default router;
